import "./NavigationModal.css";
import React from "react";

const NavigationModal = ({ isOpen, onClose, address }) => {
  if (!isOpen) return null;

  const handleNavigation = (type) => {
    let url;

    switch (type) {
      case "google":
        url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
        break;
      case "apple":
        url = `https://maps.apple.com/?daddr=${encodeURIComponent(address)}`;
        break;
      case "waze":
        url = `https://waze.com/ul?q=${encodeURIComponent(address)}`;
        break;
      default:
        return;
    }

    window.open(url, "_blank");
    onClose();
  };

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "24px",
          maxWidth: "400px",
          width: "90%",
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <h3
            style={{
              margin: "0 0 8px 0",
              fontSize: "20px",
              fontWeight: "600",
              color: "#1f2937",
            }}
          >
            🗺️ Choisir l'application de navigation
          </h3>
          <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
            Sélectionnez votre application préférée pour obtenir l'itinéraire
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {/* Google Maps */}
          <button
            type="button"
            onClick={() => handleNavigation("google")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "16px",
              border: "none",
              borderRadius: "12px",
              backgroundColor: "#4285f4",
              color: "white",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500",
              transition: "all 0.2s",
              width: "100%",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#3367d6")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#4285f4")}
          >
            <span style={{ fontSize: "20px" }}>🗺️</span>
            Google Maps
          </button>

          {/* Apple Plans */}
          <button
            type="button"
            onClick={() => handleNavigation("apple")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "16px",
              border: "none",
              borderRadius: "12px",
              backgroundColor: "#10b981",
              color: "white",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500",
              transition: "all 0.2s",
              width: "100%",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#059669")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#10b981")}
          >
            <span style={{ fontSize: "20px" }}>🍎</span>
            Plans (Apple)
          </button>

          {/* Waze */}
          <button
            type="button"
            onClick={() => handleNavigation("waze")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "16px",
              border: "none",
              borderRadius: "12px",
              backgroundColor: "#f59e0b",
              color: "white",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500",
              transition: "all 0.2s",
              width: "100%",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#d97706")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#f59e0b")}
          >
            <span style={{ fontSize: "20px" }}>🚗</span>
            Waze
          </button>
        </div>

        {/* Bouton fermer */}
        <button
          type="button"
          onClick={onClose}
          style={{
            marginTop: "20px",
            padding: "12px 24px",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            backgroundColor: "white",
            color: "#6b7280",
            cursor: "pointer",
            fontSize: "14px",
            width: "100%",
            transition: "all 0.2s",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#f9fafb";
            e.target.style.borderColor = "#9ca3af";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "white";
            e.target.style.borderColor = "#d1d5db";
          }}
        >
          Annuler
        </button>
      </div>
    </div>
  );
};

export default NavigationModal;
